import { isEqual } from 'lodash';

import { ICompany, ISanitizedCompany } from 'types/company';

export const sanitizeCompany = ({
  integrations,
  ...company
}: ICompany): ISanitizedCompany => {
  return company;
};

// The fields of the settings form that differ from what it was seeded with. Only
// these are written, so a stale or concurrently edited field (e.g. the gallery
// access key) is never overwritten with the value the form happened to load.
export const getChangedCompanyFields = <T extends object>(
  initial: T,
  current: T,
): Partial<T> =>
  Object.fromEntries(
    Object.entries(current).filter(
      ([key, value]) => !isEqual(value, initial[key as keyof T]),
    ),
  ) as Partial<T>;
